module.exports = __webpack_public_path__ + "img/LECLERCQ_80X30.67110e79.png";